// Import external
import { Component, Input, OnInit } from '@angular/core';
// Import internal
import { Project } from '@data/models/project.model';

@Component({

    selector: 'syn-project-avatar',
    templateUrl: 'project-avatar.component.html'
})
export class ProjectAvatarComponent implements OnInit {
    @Input() project: Project;
    @Input() titleInfos = '';
    @Input() showLegend = false;
    @Input() showId = false;
    @Input() caption = '';
    @Input() size = 32;
    @Input() legend = '';
    @Input() clickable = true;
    @Input() tooltip = false;
    @Input() backgroundColor: string;
    @Input() iconColor: string;

    public title = '';
    public text = '';
    public link = '/projects/';



    ngOnInit() {
        const name = this.project.name;
        const legend = this.legend || name;
        this.title = this.titleInfos ? legend + ' (' + this.titleInfos + ')' : legend;
        this.text = !this.showLegend ? this.showId ? this.project.id : '' : name || '';
        this.link += this.project.id;
    }
}
